import { Outlet } from 'react-router-dom'

export function BankSettingsShell() {
  return <Outlet />
}
